import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGeolocalizacao } from "../../../models";

interface IGeolocalizacaoState {
    selectedGeolocalizacao?: IGeolocalizacao
    geolocalizacoesEncontradas?: IGeolocalizacao[]
    clickedGeolocalizacao?: IGeolocalizacao
    searchTerm: string
    open: boolean
    radius: number
    openDialog: boolean
}

const initialState: IGeolocalizacaoState = {
    searchTerm: '',
    open: false,
    radius: 1000,
    openDialog: false
}

const selectedGeolocalizacaoInitialState: IGeolocalizacao = {
    lat: 0,
    lon: 0,
    placeRank: 0,
    name: '',
    address: {},
    type: ''
}

const geolocalizacaoSlice = createSlice({
    name: 'geolocalizacao',
    initialState,
    reducers: {
        setResetGeolocalizacaoInitialState(state) {
            state = initialState
        },
        setSearchTermState(state, action: PayloadAction<{
            searchTerm: string
        }>) {
            state.searchTerm = action.payload.searchTerm
        },
        setSelectedGeolocalizacaoState(state, action: PayloadAction<{
            geolocalizacao: IGeolocalizacao
        }>) {
            state.selectedGeolocalizacao = action.payload.geolocalizacao
        },
        setGeolocalizacoesEncontradasState(state, action: PayloadAction<{
            geolocalizacoes: IGeolocalizacao[]
        }>) {
            state.geolocalizacoesEncontradas = action.payload.geolocalizacoes
        },
        setGeolocalizacaoOpenState(state, action: PayloadAction<{
            open: boolean
        }>) {
            state.open = action.payload.open
        },
        setGeolocalizacaoRadiusState(state, action: PayloadAction<{
            radius: number
        }>) {
            state.radius = action.payload.radius
        },
        setResetSelectedGeolocalizacaoState(state) {
        //    state.selectedGeolocalizacao = {
        //         lat: 0,
        //         lon: 0,
        //         placeRank: 0,
        //         name: '',
        //         address: {},
        //         type: ''
        //     };

            state.selectedGeolocalizacao = selectedGeolocalizacaoInitialState
        },
        setClickedGeolocalizacaoState(state, action: PayloadAction<{
            geolocation: IGeolocalizacao
        }>) {
            state.clickedGeolocalizacao = action.payload.geolocation
        },
        setOpenGeolocalizacaoDialogState(state, action: PayloadAction<boolean>) {
            state.openDialog = action.payload
        },
        setResetGeolocalizacoesEncontradasState(state) {
            state.geolocalizacoesEncontradas = []
        },
        setResetSearchTermState(state) {
            state.searchTerm = ''
        },
        setResetRadiusState(state) {
            state.radius = 1000
        }
    }
})

export const {
    setResetGeolocalizacaoInitialState,
    setGeolocalizacoesEncontradasState,
    setSearchTermState,
    setSelectedGeolocalizacaoState,
    setGeolocalizacaoOpenState,
    setGeolocalizacaoRadiusState,
    setResetSelectedGeolocalizacaoState,
    setClickedGeolocalizacaoState,
    setOpenGeolocalizacaoDialogState,
    setResetGeolocalizacoesEncontradasState,
    setResetSearchTermState,
    setResetRadiusState
} = geolocalizacaoSlice.actions

export const geolocalizacaoReducer = geolocalizacaoSlice.reducer